export default __webpack_public_path__ + "static/media/area.81adf103.svg";